import { useMemo } from 'react'

import { buildBasketUpsellViewModel } from './basketUpsellViewModel'
import { useBasketUpsellFeatureFlag } from './useBasketUpsellFeatureFlag'
import { useFetchBasketUpsell } from './useFetchBasketUpsell'

type UseBasketUpsellInput = {
  basketDate?: string
  menuUuid?: string
  numPortions: number
  postcode?: string
  selectedRecipeIds: string[]
}

export const useBasketUpsell = ({
  basketDate,
  menuUuid,
  numPortions,
  postcode,
  selectedRecipeIds,
}: UseBasketUpsellInput) => {
  const isBasketUpsellEnabled = useBasketUpsellFeatureFlag()
  const shouldFetchBasketUpsells = isBasketUpsellEnabled && !!menuUuid && !!basketDate && !!postcode
  const { hasFailed, response: upsellResponse } = useFetchBasketUpsell({
    basketDate,
    enabled: shouldFetchBasketUpsells,
    menuUuid,
    numPortions,
    postcode,
    selectedRecipeIds,
  })

  const upsellCarousel = upsellResponse?.carousel
  const shouldShowBasketUpsells = shouldFetchBasketUpsells && !hasFailed && !!upsellCarousel

  const basketUpsell = useMemo(
    () =>
      buildBasketUpsellViewModel({
        shouldShowBasketUpsells,
        upsellResponse,
      }),
    [shouldShowBasketUpsells, upsellResponse],
  )

  return {
    basketUpsell,
  }
}
